(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zm-halloween-pack"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zm-halloween-pack')) {
  customElements.define('zm-halloween-pack', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.mainForm = this.dataset.productPage === 'true' ? this.closest('.product__buttons')?.querySelector('product-form form') : null;
      this.onSelection = () => this.syncSelection();
      this.mainForm?.addEventListener('change', this.onSelection);
      this.syncSelection();
      this.form.addEventListener('submit', event => this.add(event));
    }
    disconnectedCallback() {
      this.mainForm?.removeEventListener('change', this.onSelection);
      this.ready = false;
    }
    syncSelection() {
      if (this.dataset.productPage !== 'true') return true;
      const fields = this.mainForm ? new FormData(this.mainForm) : null;
      const selected = this.mainForm?.querySelector('[name="id"]')?.value === this.dataset.variant && !fields?.get('selling_plan');
      this.hidden = !selected;
      return selected;
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled || !this.syncSelection()) return;
      if (Date.now() > Date.parse('2026-11-08T23:59:59+01:00')) { this.hidden = true; return; }
      this.busy = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.button.dataset.adding;
      this.querySelector('.hw-pack-cart').hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const body = new FormData(this.mainForm || this.form);
        body.set('id', this.dataset.variant);
        body.set('quantity', this.dataset.quantity);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sectionIds = [...new Set([...(cart?.getSectionsToRender?.() || []).map(section => section.id), 'cart-icon-bubble', 'cart-icon-bubble--mobile'])].slice(0,5);
        body.set('sections', sectionIds.join(','));
        body.set('sections_url', window.location.pathname);
        cart?.setActiveElement?.(this.button);
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body});
        const added = await response.json();
        if (!response.ok) throw new Error(added.description || this.button.dataset.error);
        this.status.textContent = this.button.dataset.added;
        this.querySelector('.hw-pack-cart').hidden = false;
        try {
          cart?.renderContents?.(added);
          cart?.classList.remove('is-empty');
          for (const id of ['cart-icon-bubble', 'cart-icon-bubble--mobile']) {
            const target = document.getElementById(id);
            if (!target || !added.sections?.[id]) continue;
            const doc = new DOMParser().parseFromString(added.sections[id], 'text/html');
            target.replaceChildren(...(doc.querySelector('.shopify-section') || doc.body).childNodes);
          }
          const currentResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
          if (currentResponse.ok) {
            const current = await currentResponse.json();
            document.querySelectorAll('.mega-cart-count').forEach(count => { count.textContent = current.item_count; });
            document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:current}}));
          }
        } catch (error) { console.warn('[Halloween cart display]', error); }
      } catch (error) {
        this.status.textContent = error.message || this.button.dataset.error;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.setAttribute('aria-busy', 'false');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
